import React, { useEffect, useState } from 'react';
import { ref, getDownloadURL } from 'firebase/storage';
import { storage } from '../firebase';

const CorsTest = () => {
  const [url, setUrl] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const testRef = ref(storage, 'test-video.mp4'); // or any file path in your storage

    getDownloadURL(testRef)
      .then(setUrl)
      .catch((err) => {
        setError(err.message);
        console.error(err);
      });
  }, []);

  return (
    <div className="p-6">
      <h2 className="text-xl font-semibold">🔍 CORS Test</h2>
      {url ? (
        <video src={url} controls className="mt-4 w-full max-w-md" />
      ) : (
        <p className="text-red-500">{error || 'Loading...'}</p>
      )}
    </div>
  );
};

export default CorsTest;
